import * as React from "react";
import type { SVGProps } from "react";
const SvgXeroLogoIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={264}
    height={264}
    fill="none"
    viewBox="0 0 264 264" {...props}
  >
    <path fill="#13B5EA" d="M0 0h264v264H0z" />
    <path
      fill="#fff"
      d="M132 44c-48.6 0-88 39.4-88 88s39.4 88 88 88 88-39.4 88-88-39.4-88-88-88m35.2 123.2c-2.4 2.4-5.6 3.6-8.8 3.6s-6.4-1.2-8.8-3.6L132 149.6l-17.6 17.6c-2.4 2.4-5.6 3.6-8.8 3.6s-6.4-1.2-8.8-3.6c-4.8-4.8-4.8-12.8 0-17.6l17.6-17.6-17.6-17.6c-4.8-4.8-4.8-12.8 0-17.6s12.8-4.8 17.6 0l17.6 17.6 17.6-17.6c4.8-4.8 12.8-4.8 17.6 0s4.8 12.8 0 17.6L149.6 132l17.6 17.6c4.8 4.8 4.8 12.8 0 17.6"
    />
  </svg>
);
export default SvgXeroLogoIcon;
